import React, { useContext } from 'react';
import { BpaContext, IBpaContext } from '../../../bpaState/bpaContext';
import { BpaFields } from './BpaFields/BpaFields';
import { FieldData } from '../../InputFields';
import { Button } from 'antd';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './BpaBlock.module.scss';

interface IProps {
	allFields: FieldData;
}

export const BpaBlock: React.FC<IProps> = ({ allFields }) => {
	const {
		addBpaBlock,
		deleteBpaBlock,
		toggleIsOpenBpaBlock,
		changeName,
		changeRecipientAccountNumber,
		changeRecipientName,
		changeRecipientBank,
		changeRecipientBankCity,
		changeRecipientInn,
		changeRecipientBic,
		changeRecipientCorrespondentAccount,
		changePaymentDetails,
		changeCardContractNumber,
		changeSbpContractNumber,
		addTariff,
		deleteTariff,
		toggleIsOpenTariff,
		addCardBrand,
		deleteCardBrand,
		changeBpaPaymentSystem,
		changeCardBrand,
		changeBankFee,
		changeKMFee,
		bpa,
	} = useContext<IBpaContext>(BpaContext);

	return (
		<div className={style.container}>
			{bpa.length ? (
				bpa.map((el) => (
					<BpaFields
						key={el.id}
						bpaSet={el}
						allFields={allFields}
						deleteBpaBlock={deleteBpaBlock}
						toggleIsOpenBpaBlock={toggleIsOpenBpaBlock}
						changeName={changeName}
						changeRecipientAccountNumber={changeRecipientAccountNumber}
						changeRecipientName={changeRecipientName}
						changeRecipientBank={changeRecipientBank}
						changeRecipientBankCity={changeRecipientBankCity}
						changeRecipientInn={changeRecipientInn}
						changeRecipientBic={changeRecipientBic}
						changeRecipientCorrespondentAccount={changeRecipientCorrespondentAccount}
						changePaymentDetails={changePaymentDetails}
						changeCardContractNumber={changeCardContractNumber}
						changeSbpContractNumber={changeSbpContractNumber}
						addTariff={addTariff}
						deleteTariff={deleteTariff}
						toggleIsOpenTariff={toggleIsOpenTariff}
						addCardBrand={addCardBrand}
						deleteCardBrand={deleteCardBrand}
						changeBpaPaymentSystem={changeBpaPaymentSystem}
						changeCardBrand={changeCardBrand}
						changeBankFee={changeBankFee}
						changeKMFee={changeKMFee}
					/>
				))
			) : (
				<div className={style.divider} />
			)}
			{bpa.length < 20 && (
				<Button
					className={style.button}
					type="text"
					onClick={addBpaBlock}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#plus`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="addNewSetButton" asFragment={true} />
				</Button>
			)}
		</div>
	);
};
